exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a945f094] .md-table-head-label {\n  color: #4caf50 !important;\n}\n[data-v-a945f094] .md-table-head {\n  cursor: default;\n}\n.table-hover[data-v-a945f094] {\n  cursor: pointer;\n}\n.deductions-font[data-v-a945f094] {\n  color: red !important;\n}\n.total-style[data-v-a945f094] {\n  font-weight: bold !important;\n}\n", ""]);

// exports
